/* eslint-disable no-unused-vars */
import Vue from 'vue'

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

// Sentry.init({
//   dsn: 'https://2b901a199b39492c9ac23c102fde95d5@o44241.ingest.sentry.io/5263694',
//   integrations: [new VueIntegration({ Vue, attachProps: true })],
// });


import App from './App.vue'
import router from './router'
import './assets/tailwind.css'



import dayjs from 'dayjs'

Vue.config.productionTip = false

import VueScrollTo from "vue-scrollto";

Vue.use(VueScrollTo);

import Cloudinary from "cloudinary-vue";
Vue.use(Cloudinary, {
  configuration: {
    cloudName: "drydj65ky",
  },
});

Vue.filter('currency', function (value) {
  if (!value) return ''
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format(value)
})
Vue.filter('tightCurrency', function (value) {
  if (!value) return ''
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format(value).replace('.00', '')
})

Vue.filter('formatDate', function(value) {
  if (!value) return "";
  return dayjs(value).format('dddd, D MMM YYYY')
})

const products = require('../functions/data/products.json').products;
const flavours = require('../functions/data/flavours.json').flavours;
const groups = require('../functions/data/groups.json').groups;
const blackoutDates = require('../functions/data/blackout.json').dates;
const cakeBlackoutDates = require('../functions/data/blackout.json').cakes;
const colours = require('../functions/data/colours.json').colours;
const images = require('../functions/data/images.json');
const blackout = require('../functions/data/blackout.json');

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
    id: "UA-15414531-1"
  },
}, router);


new Vue({
  router,
  render: h => h(App),
  data: () => ({
    products,
    flavours,
    groups,
    blackoutDates,
    cakeBlackoutDates,
    images,
    colours,
    blackout
  })
}).$mount('#app')
